module.exports = __webpack_public_path__ + "static/contentselection-edgeplacement-dont-c80f961e5b00846000df949a95f79583.png";